import { render, staticRenderFns } from "./shareRecords_details.vue?vue&type=template&id=9dcc5a20&scoped=true"
import script from "./shareRecords_details.vue?vue&type=script&lang=js"
export * from "./shareRecords_details.vue?vue&type=script&lang=js"
import style0 from "./shareRecords_details.vue?vue&type=style&index=0&id=9dcc5a20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc5a20",
  null
  
)

export default component.exports